(function ($, Drupal, once, duo) {
  Drupal.behaviors.multi_select = {
    attach: function (context, settings) {
      const multiselects = document.querySelectorAll('[data-multiselect]');

      if (multiselects.length > 0) {

        $(multiselects).each(function() {
          const selectEl = $(this);
          const formItem = selectEl.closest(".form-item");

          if (
            formItem.data("select2Id") ||
            formItem.hasClass("js-webform-select2") ||
            formItem.hasClass("webform-select2") ||
            selectEl.hasClass("js-webform-select2") ||
            selectEl.hasClass("webform-select2") ||
            selectEl.hasClass("select2-widget")
          ) {
          } else {
            selectEl.SumoSelect();
          }

        });
      }

      if ($(".p-refview-news .view-filters .simpler-select").length > 0) {
        $(".p-refview-news .view-filters .simpler-select").SumoSelect();
      }
    },
  };
})(jQuery, Drupal, once, (window.duo = window.duo || {}));
